import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GrowthStandupDialogContextType {
  isDayStartOpen: boolean;
  isDayEndOpen: boolean;
  openDayStart: () => void;
  openDayEnd: () => void;
  closeDayStart: () => void;
  closeDayEnd: () => void;
}

const GrowthStandupDialogContext = createContext<GrowthStandupDialogContextType | undefined>(undefined);

export const GrowthStandupDialogProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isDayStartOpen, setIsDayStartOpen] = useState(false);
  const [isDayEndOpen, setIsDayEndOpen] = useState(false);

  const openDayStart = () => setIsDayStartOpen(true);
  const openDayEnd = () => setIsDayEndOpen(true);
  const closeDayStart = () => setIsDayStartOpen(false);
  const closeDayEnd = () => setIsDayEndOpen(false);

  return (
    <GrowthStandupDialogContext.Provider
      value={{
        isDayStartOpen,
        isDayEndOpen,
        openDayStart,
        openDayEnd,
        closeDayStart,
        closeDayEnd,
      }}
    >
      {children}
    </GrowthStandupDialogContext.Provider>
  );
};

export const useGrowthStandupDialog = () => {
  const context = useContext(GrowthStandupDialogContext);
  if (!context) {
    throw new Error('useGrowthStandupDialog must be used within a GrowthStandupDialogProvider');
  }
  return context;
};
